import { simpleLookupConfig } from "../../../../records/lookup/config/simpleLookupConfig";
import { vsLookupManagementServiceProviderName } from "../../../shared/lookups";

export const vsObjectName = "buttonPanel";

const buttonPanelUrl = "/api/machines/ButtonPanel";

export const buttonPanelLookupConfig = simpleLookupConfig(
  vsLookupManagementServiceProviderName,
  {
    name: vsObjectName,
    nameSingular: "Button Panel",
    url: buttonPanelUrl,
  }
);
